import PubSubWebsocket from "../../../../../../../commons/util/PubSubWebsocket";
import getAipUrls from "../../../../../../../config/getAipUrls";

export default new PubSubWebsocket({ websocketURL: getAipUrls().cisviewwsstepfuncsWS});

